import { FC, SVGProps } from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: string;
  isLoading?: boolean;
  color?: ButtonColor;
  size?: ButtonSize;
  alignment?: ButtonAlignment;
  startIcon?: FC<SVGProps<SVGSVGElement>>;
  startIconProps?: React.SVGAttributes<SVGSVGElement>;
  endIcon?: FC<SVGProps<SVGSVGElement>>;
  endIconProps?: React.SVGAttributes<SVGSVGElement>;
}

export enum ButtonColor {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Contrast = 'Contrast',
  Input = 'Input',
  Transparent = 'Transparent',
  Alert = 'Alert',
  Excel = 'Excel',
}

export enum ButtonSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export enum ButtonAlignment {
  Start = 'Start',
  End = 'End',
  Center = 'Center',
}
